var styles = {"container":"styles_container__Vwnde","suggestions":"styles_suggestions__fw-NV","button":"styles_button__VPCdS","smallButton":"styles_small-button__QwsUx"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
